// extracted by mini-css-extract-plugin
export default {"root":"Jwf6wm","bg":"deJLbS"};